import { useCallback } from 'react';

import { setIsSessionLost, useAppDispatch, useAppSelector } from '@fly/store';

export function useSessionLost() {
  const isSessionLost = useAppSelector(
    (state) => state.sessionLost.isSessionLost
  );
  const dispatch = useAppDispatch();
  const set = useCallback(
    (value: boolean) => {
      dispatch(setIsSessionLost(value));
    },
    [dispatch]
  );
  return { isSessionLost, setIsSessionLost: set };
}
